module.exports = __webpack_public_path__ + "static/media/no_data_available.49aec92f.png";